import React from 'react';
import { DayPickerProps, Months as Base } from 'react-day-picker-for-new-calendar';

import { Box } from '../../Box';
import { Navbar } from '../Navbar';


export const Months: DayPickerProps['components']['Months'] = props => (
    <Box position='relative'>
        <Navbar />
        <Base {...props} />
    </Box>
);
